import { render } from "./VistaLista.vue?vue&type=template&id=40a50606"
import script from "./VistaLista.vue?vue&type=script&lang=js"
export * from "./VistaLista.vue?vue&type=script&lang=js"

import "./VistaLista.vue?vue&type=style&index=0&id=40a50606&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__